var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { justify: "center" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.openPopup,
            callback: function($$v) {
              _vm.openPopup = $$v
            },
            expression: "openPopup"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", { staticClass: "card-text-styling" }, [
                _vm._v(
                  "\n        Are you sure you want to cancel this records request?\n      "
                )
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "action-btn-styling" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("leftBtnClick")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.leftBtnLabel) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("rightBtnClick")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.rightBtnLabel) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }